import React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import "./index.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';

import "./utils/language";
import { CommonInfo } from "./CommonData/Config";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
   <BrowserRouter>
      <App />
   </BrowserRouter>
);
